import React from 'react';

import styled from 'styled-components';

import { BackArrowLink } from 'components/navigation/back-arrow';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  position: fixed;
  inset-block-start: calc(3px + env(safe-area-inset-top));
  inset-inline-start: 3px;
  z-index: ${Styles.zIndex.overlay};
  margin: 1rem;
`;

interface IMobileBackButton {
  onClick?: VoidFunction;
  to: string;
}

export const MobileBackButton: React.FC<IMobileBackButton> = ({ to }) => {
  return (
    <Container>
      <BackArrowLink to={to} />
    </Container>
  );
};
